<template>
  <v-select
      v-bind:options="computedStatusOptions"
      :reduce="u => u.id"
      label="status"
      :class="{ small: small }"
      v-model="selected"
      :disabled="disabled"
      v-bind:readonly="readonly"
      :close-on-select="!multiple"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import UserAvatar from '@/components/widget/UserAvatar'

export default {
  name: 'clientStatusPicker',
  components: { UserAvatar },
  props: {
    value: { required: true },
    small: { type: Boolean, default: false },
    selectProps: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    autoInit: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    excludeMe: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    nullable: { type: Boolean, default: false }, // ✅ Added
  },
  data: () => ({
    search: '',
    allStatus: [],
  }),
  computed: {
    ...mapGetters('user', ['myId']),
    ...mapGetters('clients', ['allStatuses']),
    selected: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },

    // ✅ Computed with nullable handling
    computedStatusOptions() {
      let statuses = this.allStatus || []

      // Add nullable option if enabled (from prop or selectProps)
      const enableNullable = this.nullable || this.selectProps.nullable
      if (enableNullable) {
        return [{ id: null, status: 'NOT ASSIGNED' }, ...statuses]
      }

      return statuses
    },
  },
  created() {
    this.refreshData()
  },
  methods: {
    ...mapActions('clientStatus', ['getAllClientStatus']),
    async refreshData() {
      let statuses = await this.getAllClientStatus({})
      this.allStatus = statuses.data || []

      // ✅ Keep your existing autoInit logic
      if (this.autoInit && (this.selected == null || this.selected === '')) {
        let defaultStatus =
            this.allStatus
                .filter(
                    (s) =>
                        s.status?.toLowerCase() === 'new' ||
                        s.status?.toLowerCase() === 'lead'
                )
                .map((s) => s.id)[0] || null

        if (defaultStatus) {
          console.log('clientStatusPicker autoInit set defaultStatus', defaultStatus)
          this.$emit('input', defaultStatus)
        }
      }
    },
  },
}
</script>

<style scoped>
</style>
